import React from "react";
import "../../../css/low.css";

function Jenjang25() {
  return (
    <section className="low-section">
      <div className="her mt-5">
        <div id="low" class="cards mx-auto text-center">
          <h1 class="card-header text-center p-2">Daftar Pemenang 2025</h1>
          <h3>Pilih berdasarkan jenjang event yang kalian ikuti</h3>
          <div className="wrapper-btn text-center">
            <a
              className="btn slep"
              href="https://drive.google.com/file/d/1WjmRHjYhUtymq2PLtVMIvfj1Y6a494yY/view?usp=sharing"
              target="_blank" rel="noreferrer"
            >
              Spesial Award
            </a>
            <a
              className="btn slep"
              href="https://drive.google.com/file/d/1H7LCMVxVccrTpAPUeSHZtZilv4UohHtm/view?usp=sharing"
              target="_blank" rel="noreferrer"
            >
              Universitas
            </a>
            <a
              className="btn slep"
              href="https://drive.google.com/file/d/1l_Fhb8a1p8D0ImVAhYmwq15V332sFPFk/view?usp=sharing"
              target="_blank" rel="noreferrer"
            >
              Sekolah Menengah Atas
            </a>
            <a
              className="btn slep"
              href="https://drive.google.com/file/d/1wkZ8W5fUbmtA7Tnk5tW-qt7yt-gAyk2t/view?usp=sharing"
              target="_blank" rel="noreferrer"
            >
              Sekolah Menengah Pertama
            </a> 
            <a
              className="btn slep"
              href="https://drive.google.com/file/d/1STvZN_tFtC3OSCKDf4EyDdjK62zTNhPJ/view?usp=sharing"
              target="_blank" rel="noreferrer"
            >
              Sekolah Dasar
            </a> 
          </div>
        </div>
      </div>
    </section>
  );
}

export default Jenjang25;
